import { SectionType } from '../models/section.model';
import { FieldType, WidgetType } from '../models/element-types';
import { BuilderElementType } from './element-utils';

export abstract class SelectorUtil {
    public static readonly sectionAttr = 'data-section';
    public static readonly submitForAttr = 'data-submit-for';
    public static readonly rowAttr = 'data-mesh-row';
    public static readonly columnAttr = 'data-mesh-col';
    public static readonly meshContainerAttr = 'data-mesh-container';
    public static readonly meshAttr = 'data-mesh';
    public static readonly dataSectionAreaAttr = 'data-section-area';
    public static readonly elementAttr = 'data-element';
    public static readonly widgetAttr = 'data-widget';
    public static readonly fieldAttr = 'data-field';
    public static readonly elementGroupAttr = 'data-group';
    public static readonly variantAttr = 'data-variant';

    public static readonly hiddenVarsBlockId = 'hidden-fields-container';

    public static readonly section: SectionSelector = {
        base: `[${this.sectionAttr}]`,
        form: `[${this.sectionAttr}="form"]`,
        header: `[${this.sectionAttr}="header"]`,
        footer: `[${this.sectionAttr}="footer"]`,
        common: `[${this.sectionAttr}="common"]`,
        submit: `[${this.sectionAttr}="submit"]`
    };

    public static readonly row: RowSelector = {
        base: `[${this.rowAttr}]`
    };

    public static readonly column: ColumnSelector = {
        base: `[${this.columnAttr}]`
    };

    public static readonly mesh: MeshSelector = {
        base: `[${this.meshAttr}]`,
        meshContainer: `[${this.meshAttr}] [${this.meshContainerAttr}]`
    };

    public static readonly dataSectionArea: DataSectionAreaSelector = {
        base: `[${this.dataSectionAreaAttr}]`,
        content: `[${this.dataSectionAreaAttr}] .content`
    };

    public static readonly builderElement: ElementSelector = {
        base: `[${this.elementAttr}]`,
        field: `[${this.elementAttr}="field"]`,
        widget: `[${this.elementAttr}="widget"]`,
        hidden: `[${this.elementAttr}="hidden"]`
    };

    public static readonly widget: WidgetSelector = {
        base: `[${this.widgetAttr}]`,
        submit: `[${this.widgetAttr}="submit"]`,
        divider: `[${this.widgetAttr}="divider"]`,
        text: `[${this.widgetAttr}="text"]`,
        header: `[${this.widgetAttr}="header"]`,
        image: `[${this.widgetAttr}="image"]`,
        spacer: `[${this.widgetAttr}="spacer"]`,
        signin: `[${this.widgetAttr}="signin"]`,
        signup: `[${this.widgetAttr}="signup"]`,
        forgotpassword: `[${this.widgetAttr}="forgotpassword"]`
    };

    public static readonly field: FieldSelector = {
        base: `[${this.fieldAttr}]`,
        text: `[${this.fieldAttr}="text"]`,
        email: `[${this.fieldAttr}="email"]`,
        firstname: `[${this.fieldAttr}="firstname"]`,
        lastname: `[${this.fieldAttr}="lastname"]`,
        companyname: `[${this.fieldAttr}="companyname"]`,
        birthday: `[${this.fieldAttr}="birthday"]`,
        signature: `[${this.fieldAttr}="signature"]`,
        subscribe: `[${this.fieldAttr}="subscribe"]`,
        file: `[${this.fieldAttr}="file"]`,
        textarea: `[${this.fieldAttr}="textarea"]`,
        number: `[${this.fieldAttr}="number"]`,
        tel: `[${this.fieldAttr}="tel"]`,
        radio: `[${this.fieldAttr}="radio"]`,
        date: `[${this.fieldAttr}="date"]`,
        url: `[${this.fieldAttr}="url"]`,
        checkbox: `[${this.fieldAttr}="checkbox"]`,
        dropdown: `[${this.fieldAttr}="dropdown"]`,
        hidden: `[${this.fieldAttr}="hidden"]`,
        password: `[${this.fieldAttr}="password"]`,
        captcha: `[${this.fieldAttr}="captcha"]`,
        gdpr: `[${this.fieldAttr}="gdpr"]`,
    };
}

type BaseSelector = { base: string };
type SectionSelector = BaseSelector & { [key in SectionType]: string };
type RowSelector = BaseSelector;
type ColumnSelector = BaseSelector;
type MeshSelector = BaseSelector & { meshContainer: string };
type DataSectionAreaSelector = BaseSelector & { content: string };
type ElementSelector = BaseSelector & { [key in BuilderElementType]: string };
type WidgetSelector = BaseSelector & { [key in WidgetType]: string };
type FieldSelector = BaseSelector & { [key in FieldType]: string };
